import { PayloadAction } from '@reduxjs/toolkit';

import { AppState, LoaderType } from 'editor/src/store/app/types';

const addLoaderReducer = (state: AppState, { payload }: PayloadAction<LoaderType>) => {
  state.activeLoaders[payload] = true;
};

export default addLoaderReducer;
